export const GET_GAME = 'GET_GAME';// 获取所有游戏



